// Angular
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
// Model
import {
	BroadcastService,
	SubContent,
	GENERAL_EVENT_TYPE,
	SignalRService
} from '@cv-invision/core';
import { AutoQCStatusKeyModel, AutoQCStatusModel } from '../model/order-inbox.model';
// Service
import { OrderInboxService } from '../service/order-inbox.service';
import { DialogService } from 'primeng/dynamicdialog';
// Component
import { OrderActivitDialogComponent } from '../dialogs/order-activity/order-activity-dialog.component';

@Component({
	selector: 'cv-order-content-detail',
	templateUrl: './order-content-detail.component.html',
	styleUrls: ['./order-content-detail.component.scss']
})
export class OrderContentDetailComponent extends SubContent implements OnInit {
	@Input() data: any;
	@Output() successEvent: EventEmitter<any> = new EventEmitter<any>();
	@Output() errorEvent: EventEmitter<any> = new EventEmitter<any>();
	orderUsers: Array<any> = [];
	public orderDetailFields: Array<any> = [];
	public mainPicture;
	isGSE: boolean;
	public orderAutoQCstatus = new AutoQCStatusKeyModel();
	loading = true;

	constructor(
		broadcastService: BroadcastService,
		private orderInboxService: OrderInboxService,
		private signalRService: SignalRService,
		private dialogService: DialogService
	) {
		super(broadcastService);
	}

	ngOnInit(): void {
		if (this.data && this.data.id) {
			this.orderDetailFields = [
				{ name: 'Provider', value: this.data.externalProvider },
				{ name: 'Reference ID', value: this.data.externalId },
				{ name: 'Reviewer Name', value: this.data.reviewer ? this.data.reviewer.fullName : null },
				{ name: 'Document Id', value: this.data.documentId },
				{ name: 'Schema', value: this.data.schema },
				{
					name: 'User',
					value:
						this.data.orderedBy && this.data.orderedBy.fullName ? this.data.orderedBy.fullName : ''
				}
			];

			if (this.data.lockedBy) {
				this.orderDetailFields.push({
					name: 'Locked By',
					value: `${this.data.lockedBy.firstName} ${this.data.lockedBy.lastName || ''}`
				})
			}
			this.isGSE = this.data.statusReason === 'GSEValidation';
			this.getCurrentUserOnOrder();
			this.orderInboxService.getInboxMainPicture(this.data.id).subscribe((mainPicture: any) => {
				this.mainPicture = mainPicture;
				this.openSubContent(null, null);
			});

			this.orderAutoQCstatus = new AutoQCStatusKeyModel();
			this.orderInboxService.getOrderAutoQcStatus(this.data.id).subscribe((autoQcResponse: AutoQCStatusModel) => {
				if (autoQcResponse.isValid) {
					this.orderAutoQCstatus = autoQcResponse.key;
				}
				this.loading = false;
			});
		}
	}

	/**
	 * get the users working on a order
	 */
	getCurrentUserOnOrder(): void {
		this.signalRService
			.invokeHubPublic(GENERAL_EVENT_TYPE.MEMBERS, `orders:${this.data.id}`)
			.then(data => {
				if (data.length) {
					const us = data.map(u => {
						return {
							...u,
							initials: u.fullName
								.split(' ')
								.map(x => x.charAt(0))
								.join('')
								.substr(0, 2)
								.toUpperCase()
						};
					});
					this.orderUsers = us;
				} else {
					this.orderUsers = [];
				}
			}).catch(() => {
				this.orderUsers = [];
			});
	}

	/**
	 * Opens the Order Activity dialog for the current order.
	 * Passes the order ID as data and applies custom styling and dimensions.
	 */
	openOrderActivityDialog(): void {
		this.dialogService.open(OrderActivitDialogComponent, {
			width: '718px',
			height: '640px',
			header: 'Activity Log',
			data: {
				orderId: this.data.id
			},
			styleClass: 'order-activity-dialog'
		});
	}
}
